<template>
  <div>

<!--    <div v-if="$store.state.isLogin === true && $store.state.authType === UserAuthType_Admin">-->
<!--      <el-button @click="goEditBlog">写博客</el-button>-->
<!--      <el-button @click="goEditBlog">新标签</el-button>-->
<!--      <el-button @click="goEditBlog">标签管理</el-button>-->
<!--    </div>-->

    <el-container>
      <el-aside width="calc(100% - 455px)">
        <div v-for="(item,index) in blogList" :key="index">
          <BlogItem :data="item"></BlogItem>
        </div>
      </el-aside>

      <el-main>

        <BlogTagWidget></BlogTagWidget>
        <el-calendar></el-calendar>

      </el-main>
    </el-container>

  </div>
</template>

<script>
import BlogItem from './BlogItem'
import BlogTagWidget from './BlogTagWidget'
import {getBlogList} from '../../../../request/api'
import Common from '../../../../js/Common'
export default {
  name: 'Blog',
  components: {BlogItem, BlogTagWidget},
  data () {
    return {
      blogList: [],
      UserAuthType_Admin: Common.UserAuthType.UserAuthType_Admin
    }
  },
  methods: {
    init () {
      getBlogList().then(res => {
        console.log(res)

        if (res.code === '90') {
          this.blogList = res.data
        } else {
          this.$message.error(res.msg)
        }
      }).catch((error) => {
        // error

        console.log(error)
      })
    },
    goEditBlog () {
      this.$router.push('/blog/add_blog')
    }
  },
  created () {
    this.init()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pc/pages/blog/Blog.vue